import TYPES from './types';
import COMMON_TYPES from '../../../actions/types';
import { showNotificationLayer } from '../../../actions/notification';
import {
  commentManifestation,
  changeStatusManifestation,
} from '../../../api/manifestation';

const loadingPost = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const createComment = params => {
  const {
    id,
    comment,
    statusId,
  } = params.formParams || {};

  return async dispatch => {
    try {
      dispatch(loadingPost());

      const [, response] = await Promise.all([
        changeStatusManifestation({
          id,
          statusId,
        }),
        commentManifestation({ id, comment }),
      ]);

      dispatch(loadingPost());
      dispatch(toggleFormCommentLayer());

      dispatch({
        type: TYPES.updateItemListing,
        payload: response,
      });

      dispatch(
        showNotificationLayer(`A alteração da manifestação ${response?.data?.protocol} foi salva!`)
      );
    }
    catch (responseFail) {
      dispatch(loadingPost());

      dispatch({
        type: COMMON_TYPES.formPostResultError,
        payload: responseFail?.response?.data,
      });
    }
  }
};

export const toggleFormCommentLayer = params => {
  if(params && params.id) {
    return [
      {
        type: COMMON_TYPES.toggleLayer,
        payload: 'createComment',
      },
      { type: COMMON_TYPES.formInitializeValues, payload: params },
    ];
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.formClearValues },
  ];
};
